import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import SectionWrapper from "../components/SectionWrapper";
import { getConfig } from "../api/config";
import { getAllKnowledgeEvents } from "../api/eventApi";
import {
    normalizeKnowledgeEvents,
    formatKnowledgeEventDate,
} from "../utils/knowledgeCenter";

const BlogDetails = () => {
    const { id } = useParams();

    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadBlog = async () => {
            try {
                setLoading(true);

                const config = await getConfig();
                const response = await getAllKnowledgeEvents();

                const blogs = normalizeKnowledgeEvents(response, config.baseUrl);

                const selectedBlog = blogs.find(
                    (item) => String(item.id) === String(id)
                );

                setBlog(selectedBlog || null);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        loadBlog();
    }, [id]);

    if (loading) {
        return (
            <main className="mt-24 min-h-screen bg-cream">
                <SectionWrapper>
                    <div className="py-20 text-center text-lg font-medium text-maroon">
                        Loading...
                    </div>
                </SectionWrapper>
            </main>
        );
    }

    if (!blog) {
        return (
            <main className="mt-24 min-h-screen bg-cream">
                <SectionWrapper>
                    <div className="py-20 text-center">
                        <h2 className="text-3xl font-bold text-maroon">
                            Blog Not Found
                        </h2>

                        <Link
                            to="/knowledge-center"
                            className="mt-8 inline-flex rounded-xl bg-maroon px-6 py-3 text-white"
                        >
                            Back to Blogs
                        </Link>
                    </div>
                </SectionWrapper>
            </main>
        );
    }

    return (
        <main className="mt-20 bg-cream pb-20">
            <SectionWrapper>

                <Link
                    to="/blogs"
                    className="mb-8 inline-flex items-center text-maroon hover:underline"
                >
                    ← Back to Blogs
                </Link>

                <motion.article
                    initial={{ opacity: 0, y: 25 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                    className="overflow-hidden rounded-3xl bg-white shadow-xl"
                >
                    {/* <div className="w-full bg-slate-100"> */}
                    {/* <div className="flex overflow-hidden justify-center items-center h-[100px] md:h-[200px] bg-slate-100">
                        <img
                            src={blog.image}
                            alt={blog.title}
                            //   className="h-[300px] w-full object-cover md:h-[500px]"
                            className="h-full w-full object-contain object-center p-2"
                        />
                    </div> */}

                    <div className="p-6 md:p-10">

                         <div className="flex justify-start place-items-start h-[300px] md:h-[400px">
                        <img
                            src={blog.image}
                            alt={blog.title}
                            //   className="h-[300px] w-full object-cover md:h-[500px]"
                            className="h-full w-full object-contain object-center p-2"
                        />
                    </div>

                        <span className="rounded-full bg-maroon/10 px-4 py-2 text-sm font-semibold text-maroon">
                            {/* Blogs */}
                            {blog.heading || "Blog / Media / Event"}
                        </span>

                        <h1 className="mt-5 text-3xl font-bold text-maroon md:text-5xl">
                            {blog.title}
                        </h1>

                        {/* <p className="mt-4 text-sm text-gray-500">
                            {formatKnowledgeEventDate(blog.eventDate)}
                        </p> */}

                        <div className="mt-8 border-t pt-8">

                            {/* Plain text description */}

                            <p className="whitespace-pre-line font-extralight *:text-sm">
                                {blog.description}
                            </p>


                        </div>

                    </div>
                </motion.article>

            </SectionWrapper>
        </main>
    );
};

export default BlogDetails;